(function() {
    'use strict';

    angular
        .module('serviciosocialApp')
        .controller('BuscadorProyectosSolicitudController', BuscadorProyectosSolicitudController);

    BuscadorProyectosSolicitudController.$inject = ['$timeout', '$scope', '$state', '$stateParams', 'entity', 'selectedTab'];

    function BuscadorProyectosSolicitudController ($timeout, $scope, $state, $stateParams, entity, selectedTab) {
        var vm = this;

        vm.sSProyecto = entity;
        vm.selectedTab = selectedTab;
        vm.clear = clear;
                
        loadProject();
        
        function loadProject(){
        	vm.isDisabled = true;
            $scope.active = vm.selectedTab;
        }
        
        function clear () {
        	$state.go("buscador-proyectos");
        }

    }
})();
